export const calendarLocalStorageConstants = {
  IS_SIDELIST_OPENED_ON_LISTVIEW: "isSideListOpenedOnListView"
};

export const lawsuitsAndCasesLocalStorageConstants = {
  LAWSUITS_AND_CASES: "lawsuitsAndCases",
  LAWSUITS_AND_CASES_MOVEMENTS: "lawsuitsAndCasesMovements"
};
